import useGetApi from 'src/api/useGetApi';
import { RebateAgreementListItem } from './types';

interface QueryParams {
  supplierId?: string; // Keep camelCase for frontend, will be converted by backend
  year?: number; // Deprecated: use years instead
  years?: number[]; // Array of years to filter by
}

const useRebateAgreements = (params?: QueryParams, enabled?: boolean) => {
  // Convert years array to comma-separated string for backend
  const queryParams = params
    ? {
        ...params,
        years:
          params.years && params.years.length > 0
            ? params.years.join(',')
            : undefined,
      }
    : undefined;

  return useGetApi<RebateAgreementListItem[]>({
    endpoint: 'rebates/agreements',
    queryParameters: queryParams,
    options: {
      enabled,
    },
  });
};

export default useRebateAgreements;
